import { useContext } from 'react';
import { StorageContext } from '../hoc/StorageProvider';

export function useStorage() {
	const context = useContext(StorageContext);
	if (context === null) {
		throw new Error('useStorage must be used within a StorageProvider');
	}
	return context;
}
